/* covered.ro · Black Friday 1+1 (sections/cv-bf-hero.liquid, sections/cv-bf-countdown.liquid,
   snippets/cv-bf-countdown.liquid). Progressive enhancement only: without this file every state is complete
   (Liquid renders it from the theme settings, the countdown with its values at render time).
   1. Countdown (cv-bf-countdown, real dates only): ticks every second from the visitor's clock, on the next
      whole second of the time left (no interval drift). Before the start it counts to the start; when the
      start passes it switches label, screen-reader sentence and target to the end, without a reload; the
      "zile" tile goes at 0 days; at the end it hides itself (or its closest [data-cd-root]). A page rendered
      "live" always counts to the end (its label and sentence say so), even on a clock still before the start.
      Paused while the tab is hidden (timer cleared), re-synced when it comes back. At the start and at the end
      it also tells the hero ("cv-bf:clock" on the document), so after a wall-clock jump (a desktop waking from
      sleep with the tab visible: timers were frozen, no visibilitychange) the hero and every countdown switch
      together on the next tick. A changed digit gets a short settle (the seconds only a light fade), never
      under prefers-reduced-motion or disabled animations (the digits still update).
   2. Hero clock (soon / live pages): when the start passes on an open or cached page, the eyebrow switches
      from "de pe …" to "până pe …", the soon-only fine print to the normal one, and a homepage "Black Friday
      începe în" title gives way to the normal title. When the end passes, the hero becomes the "ended" hero (as
      a fresh load would render it): no gift figure, no countdown, no offer copy, "s-a încheiat.", the button to
      all products; how-it-works, the table and the sections listed in "ended_hide" are hidden. Its own timer
      waits for the next start / end; a countdown's "cv-bf:clock" re-checks it at once. Paused while the tab is
      hidden, re-synced when it comes back.
   3. Flip-through: shows the other skins once (1.1 s each, ≤ 4.4 s) and ends on the first one. Never loops.
      Starts only after the "?" and the GRATUIT tag have landed (+ 1.2 s), with autoplay, motion allowed, no
      Save-Data, after load + idle, when the phones are half visible (in the theme editor the section prints no
      template[data-skins], so it never starts there). Stops (back to the first skin) on focus inside the
      stage or a hidden tab.
   4. Theme editor: selecting a skin block shows it, deselecting goes back to the first one.
   No scroll listeners, no rAF loops, no requests of its own (images come from the section's template). */
(() => {
  const D = document;
  const $ = (el, sel) => el.querySelector(sel);
  const sleep = (ms) => new Promise((ok) => setTimeout(ok, ms));
  const still = matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('cv-bf-countdown'))
    customElements.define(
      'cv-bf-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.ac = new AbortController();
          D.addEventListener('visibilitychange', () => (D.hidden ? clearTimeout(this.t) : this.tick()), { signal: this.ac.signal });
          this.tiles = [...this.querySelectorAll('[data-cd]')].map((t) => ({ t, k: t.dataset.cd, n: $(t, '.cv-bf-cd__n'), u: $(t, '.cv-bf-cd__u') }));
          this.tick();
        }

        disconnectedCallback() {
          this.ac.abort();
          clearTimeout(this.t);
        }

        tick() {
          clearTimeout(this.t);
          const d = this.dataset;
          const now = Date.now();
          const start = +d.start || 0;
          const end = +d.end || 0;
          if (!end || now >= end) return this.done();
          if (now >= start && d.phase != 'live') this.live();
          // Rendered (or switched) "live": always to the end, as the label and the sentence say
          const ms = (d.phase == 'live' ? end : start) - now;
          const left = Math.ceil(ms / 1000);
          const days = Math.floor(left / 86400);
          const h = Math.floor((left % 86400) / 3600);
          const m = Math.floor((left % 3600) / 60);
          const u = (d.units || '').split('|');
          const two = (x) => String(x).padStart(2, '0');
          const val = { d: [`${days}`, days == 1 ? u[0] : u[1]], h: [two(h), h == 1 ? u[2] : u[3]], m: [two(m), u[4]], s: [two(left % 60), u[5]] };
          const move = this.ran && !still.matches && !D.body.classList.contains('disable-animations');
          for (const x of this.tiles) {
            const [v, unit] = val[x.k] || [];
            if (v === undefined || !x.n) continue;
            if (x.k == 'd') {
              x.t.hidden = !days;
              x.t.toggleAttribute('data-long', days > 99);
            }
            if (unit && x.u && x.u.textContent != unit) x.u.textContent = unit;
            if (x.n.textContent != v) {
              x.n.textContent = v;
              // the seconds change every second: a light fade only; minutes, hours and days drop in
              if (move)
                x.n.animate?.(
                  x.k == 's' ? [{ opacity: 0.6 }, { opacity: 1 }] : [{ opacity: 0.35, transform: 'translateY(-0.14em)' }, { opacity: 1, transform: 'none' }],
                  { duration: x.k == 's' ? 240 : 320, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
                );
            }
          }
          this.ran = 1;
          // The next whole second of the time left (+ a margin, so the rounding has moved on)
          this.t = setTimeout(() => this.tick(), (ms % 1000 || 1000) + 25);
        }

        // The start has passed: count to the end, with the campaign's label and sentence
        live() {
          const d = this.dataset;
          d.phase = 'live';
          const label = $(this, '[data-cd-label]');
          if (label) {
            label.textContent = d.labelLive || '';
            label.hidden = !d.labelLive;
          }
          const sr = $(this, '[data-cd-sr]');
          if (sr) sr.textContent = d.srLive || '';
          D.dispatchEvent(new Event('cv-bf:clock'));
        }

        done() {
          clearTimeout(this.t);
          (this.closest('[data-cd-root]') || this).hidden = true;
          D.dispatchEvent(new Event('cv-bf:clock'));
        }
      }
    );

  if (customElements.get('cv-bf-hero')) return;
  customElements.define(
    'cv-bf-hero',
    class extends HTMLElement {
      connectedCallback() {
        const ac = (this.ac = new AbortController());
        const on = (type, fn, el = D) => el.addEventListener(type, fn, { signal: ac.signal });
        const box = (this.box = $(this, '[data-box]'));
        const tpl = $(this, 'template[data-skins]');
        this.tick();
        on('visibilitychange', () => (D.hidden ? (clearTimeout(this.t), this.rest()) : this.tick()));
        // A countdown reached the start or the end (its second timer noticed a clock jump first)
        on('cv-bf:clock', () => D.hidden || this.tick());
        on('shopify:block:select', (e) => box.contains(e.target) && this.show(e.target, 1));
        on('shopify:block:deselect', () => this.show(box.firstElementChild, 1));
        // Keyboard focus on a brand chip under the rail's edge fade: Chromium leaves a partly visible focused item
        // where it is; bring it in (the rail's scroll-padding = the fade). Touch and mouse focus: nothing.
        const rail = $(this, '.cv-bf-hero__chip-list');
        const kb = (el) => {
          try {
            return el.matches(':focus-visible');
          } catch {
            return true;
          }
        };
        if (rail) on('focusin', (e) => kb(e.target) && e.target.scrollIntoView({ block: 'nearest', inline: 'nearest' }), rail);
        if (
          !tpl ||
          this.dataset.autoplay != 'true' ||
          !('IntersectionObserver' in window) ||
          matchMedia('(prefers-reduced-motion: reduce)').matches ||
          D.body.classList.contains('disable-animations') ||
          navigator.connection?.saveData
        )
          return;
        on('focusin', () => this.rest(), $(this, '.cv-bf-hero__stage'));
        const arm = async () => {
          // Let the reveal finish first: the "?" and the GRATUIT tag land, then a beat to read them.
          const last = $(this, '.cv-bf-hero__tag') || $(this, '.cv-bf-hero__q');
          await Promise.all((last?.getAnimations?.() || []).map((a) => a.finished.catch(() => 0)));
          await sleep(1200);
          if (!this.isConnected || this.classList.contains('cv-bf-hero--inactive')) return;
          const io = (this.io = new IntersectionObserver(([e]) => e.isIntersecting && (io.disconnect(), this.flip(tpl)), { threshold: 0.5 }));
          io.observe($(this, '.cv-bf-hero__pair'));
        };
        const idle = () => (window.requestIdleCallback ? requestIdleCallback(arm, { timeout: 1500 }) : setTimeout(arm, 200));
        D.readyState == 'complete' ? idle() : on('load', idle, window);
      }

      disconnectedCallback() {
        this.ac.abort();
        this.io?.disconnect();
        clearTimeout(this.t);
        this.on = 0;
      }

      tick() {
        clearTimeout(this.t);
        const d = this.dataset;
        if (!d.end || this.classList.contains('cv-bf-hero--inactive')) return;
        const now = Date.now();
        let next = d.end - now + 50;
        if (d.start && now < d.start) next = d.start - now + 50;
        else if (d.state == 'soon') this.begin();
        if (now >= d.end) return this.end();
        // The start or the end, whichever comes next. setTimeout fires at once above 2^31 ms (about 24.8 days):
        // far dates are re-checked once a day. (The countdown keeps its own second timer.)
        this.t = setTimeout(() => this.tick(), Math.min(next, 864e5));
      }

      // The start has passed on a "soon" page: the live wording (the cart now adds the free skin), and a
      // homepage "Black Friday începe în" title gives way to the normal title and eyebrow.
      begin() {
        this.dataset.state = 'live';
        this.classList.replace('cv-bf-hero--soon', 'cv-bf-hero--live');
        const when = $(this, '[data-when]');
        if (when?.dataset.live) when.textContent = `· ${when.dataset.live}`;
        this.querySelectorAll('[data-fine]').forEach((p) => (p.hidden = p.dataset.fine != 'live'));
        this.querySelectorAll('[data-soon-only]').forEach((el) => el.remove());
        this.querySelectorAll('[data-live-only]').forEach((el) => (el.hidden = false));
      }

      // The end has passed on an open page: the hero and the page as a fresh load would render them.
      end() {
        clearTimeout(this.t);
        this.rest();
        if (this.dataset.state == 'soon') this.begin();
        this.dataset.state = 'ended';
        this.classList.add('cv-bf-hero--inactive', 'cv-bf-hero--ended');
        const tpl = $(this, 'template[data-ended]');
        if (tpl) {
          const c = tpl.content;
          const l2 = $(this, '[data-line-2]');
          const nl2 = $(c, '[data-l2]');
          if (l2 && nl2) l2.textContent = nl2.textContent;
          // The offer's countdown and buttons leave the head; the ended button and text go first in the body.
          this.querySelectorAll('.cv-bf-hero__head > .cv-bf-cd, .cv-bf-hero__head > .cv-bf-hero__ctas, .cv-bf-hero__body > .cv-bf-hero__text').forEach((el) => el.remove());
          const body = $(this, '.cv-bf-hero__body');
          const add = ['.cv-bf-hero__ctas', '.cv-bf-hero__text'].map((sel) => $(c, sel)?.cloneNode(true)).filter(Boolean);
          if (body) body.prepend(...add);
          const say = $(this, '[data-announce]');
          if (say) say.textContent = `${$(this, 'h1, h2')?.textContent.replace(/\s+/g, ' ').trim() || ''}`;
        }
        if (!D.getElementById('cv-bf-ended-style')) {
          const st = D.createElement('style');
          st.id = 'cv-bf-ended-style';
          st.textContent = `[data-cv-bf-ended-hide]${this.dataset.hide ? `,${this.dataset.hide}` : ''}{display:none!important}`;
          D.head.append(st);
        }
      }

      async flip(tpl) {
        const box = this.box;
        const first = box.firstElementChild;
        box.append(tpl.content.cloneNode(true));
        const layers = [...box.children].slice(1);
        this.on = 1;
        // Wait until the images are decoded (max 2.5 s); a skin whose image failed is skipped.
        await Promise.race([Promise.all(layers.map((l) => $(l, 'img')?.decode().then(() => (l.ok = 1), () => 0))), sleep(2500)]);
        for (const l of [...layers.filter((x) => x.ok), first]) {
          await sleep(1100);
          if (!this.on) return; // stopped: rest() already showed the first skin
          this.show(l);
        }
        this.on = 0;
      }

      rest() {
        if (this.on) {
          this.on = 0;
          this.show(this.box.firstElementChild);
        }
      }

      show(layer, instant) {
        if (!layer?.matches('[data-skin]')) return;
        for (const l of this.box.children) {
          if (instant) l.style.transition = 'none';
          l.toggleAttribute('data-active', l == layer);
        }
        const name = $(this, '[data-skin-name]');
        const link = $(this, '[data-link]');
        if (name && layer.dataset.name) name.textContent = layer.dataset.name;
        if (link && layer.dataset.url) link.href = layer.dataset.url;
      }
    }
  );
})();
